export default "__VITE_ASSET__BkaCZRi0__"